import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewChild, Input } from '@angular/core';
import { IProductMultipleSelection, ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ProductoService } from 'src/app/services/producto.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { DatesService } from 'src/app/shared/services/dates.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ModalAddeditDescuentosTopesComponent } from './modal-addedit-descuentos-topes.component';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { debounceTime, filter } from 'rxjs/operators';
import gql from 'graphql-tag';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-descuentos-topes',
  templateUrl: './descuentos-topes.component.html',
  styleUrls: ['./descuentos-topes.component.scss'],
  providers: [SecurityService],
})
export class DescuentosTopesComponent implements OnInit, OnDestroy {
  @ViewChildren(ModalSeleccionarProductoComponent) modalSeleccionarProducto: QueryList<ModalSeleccionarProductoComponent>;
  @ViewChild(ModalAddeditDescuentosTopesComponent, { static: true }) agregarDescuentoModal: ModalAddeditDescuentosTopesComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  @Input() permiteUnidadNegocio: any = [];

  readonly MODAL_SEL_PROD_DESCUENTO = 'MODAL_SEL_PROD_DESCUENTO';
  defaultUnidadNegocio: number = null;
  productosMultiplesSeleccionados: any[] = null;
  readonly RO_EstadoActivoMax: boolean = true;
  readonly RO_EstadoInactivoMax: boolean = false;

  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  listaDescuentos: any = null;

  formDetails: FormGroup;
  private log: any;
  private subs = new Subscription();

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  private rutUsuario: Number;

  modalConfirmTitle: String = '';
  modalConfirmContent: String = '';

  constructor(
    private clog: ConsoleService,
    private gqlclient: GraphQLClient,
    private formValidatorsService: FormValidatorsService,
    private productoService: ProductoService,
    private messageRendererService: MessageRendererService,
    private accesolocalstorage: SecurityService,
    private datesService: DatesService,
    private toastrService: ToastService,
    private fb: FormBuilder
  ) {
    this.log = this.clog.log('MODAL-DCTOS-ESPECIALES');
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();
    this.rutUsuario = this.accesolocalstorage.getRutUsuario();
    this.createForms();
    this.formChangesSubscriptions();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  trackByDescuentoCodigo(index: number, item: any) {
    return item && item.codigo != null ? item.codigo : index;
  }

  formChangesSubscriptions() {
    this.subs.add(
      this.formDetails
        .get('codigoProducto')
        .valueChanges.pipe(filter(Boolean))
        .subscribe((codProduct: string) => {
          this.modalDescuento.searchByCodeProduct(codProduct);
        })
    );
  }

  createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formDetails = this.fb.group({
      codigoProducto: ['', [Validators.required, Validators.min(1)]],
      fechaInicio: [initDate, [Validators.required]],
      estadoActMax: [this.RO_EstadoActivoMax],
    });
  }

  // getters
  get modalDescuento() {
    return this.modalSeleccionarProducto.filter((mod) => mod.origen === this.MODAL_SEL_PROD_DESCUENTO)[0];
  }

  abrirModalSeleccionarProducto() {
    this.modalDescuento.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio,
    });
  }

  abrirModalSeleccionarProductosSeleccionados() {
    this.modalDescuento.showSelected(this.productosMultiplesSeleccionados);
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productosMultiplesSeleccionados = [];
    this.productosMultiplesSeleccionados.push(_productoSeleccionado);
    this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku);
    // this.setCodigoProductoValidators('ADD')
  }

  onProductoNoEncontrado() {
    this.productosMultiplesSeleccionados = null;
  }

  onMultiplesProductosSeleccionados(data: IProductMultipleSelection) {
    this.log(data);
    this.productosMultiplesSeleccionados = data.data;
    if (data.data.length === 1) {
      this.formDetails.get('codigoProducto').setValue(data.data[0].sku);
      this.setCodigoProductoValidators('ADD');
    } else {
      this.formDetails.get('codigoProducto').setValue('');
      this.setCodigoProductoValidators('REMOVE');
    }
  }

  setCodigoProductoValidators(type: 'ADD' | 'REMOVE') {
    if (type === 'ADD') {
      this.formDetails.get('codigoProducto').setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.formDetails.get('codigoProducto').setValidators([]);
    }
    this.formDetails.get('codigoProducto').updateValueAndValidity();
  }

  uncheckProducto(producto) {
    this.productosMultiplesSeleccionados = this.productosMultiplesSeleccionados.filter((p) => p.sku !== producto.sku);
    if (this.productosMultiplesSeleccionados.length === 0) this.productosMultiplesSeleccionados = null;
  }

  ver({ rut_empresa, sucursal_codigo, codigo }) {
    this.log(Number(this.rutEmpresa), codigo);
    this.agregarDescuentoModal.load(rut_empresa, sucursal_codigo, codigo, false);
  }

  editar({ rut_empresa, sucursal_codigo, codigo }) {
    this.log(Number(this.rutEmpresa), codigo);
    this.agregarDescuentoModal.load(rut_empresa, sucursal_codigo, codigo, true);
  }

  getProductsByUnidadNegocio({ inputParams, callback }) {
    if (this.permiteUnidadNegocio) {
      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: inputParams.unidad_negocio_codigo ? inputParams.unidad_negocio_codigo : this.defaultUnidadNegocio,
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina,
      };

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams));

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    } else {
      this.log('inputParams', JSON.stringify(inputParams));
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    }
  }

  /*BUSQUEDA POR FILTRO*/
  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1;
    // this.validateAllFormFields(this.formData);
    // if (!this.formData.valid) {
    //   return
    // }

    const inputData = {
      filtroExacto: {
        exacto: {
          cabecera: {
            codigo: -1,
            rut_empresa: Number(this.rutEmpresa),
            sucursal_codigo: Number(this.sucursalEmpresa),
            fecha_inicio: this.formDetails.get('fechaInicio').value || '0001-01-01',
            activado: this.formDetails.get('estadoActMax').value,
          },
          detalleProductos: [],
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };
    if (this.productosMultiplesSeleccionados) {
      inputData.filtroExacto.exacto.detalleProductos = this.productosMultiplesSeleccionados.map((p) => ({ producto_codigo: p.codigo }));
    }

    this.log(JSON.stringify(inputData));
    this.loaded = false;
    this.loading = true;
    this.listaDescuentos = [];

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($filtroExacto: FiltroInputTypeOfdescuentoDTOMaximodescuentoDTOMaximoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            descuento_maximo {
              obtenerSegunFiltro(filtro: $filtroExacto, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  registros {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_inicio
                    fecha_termino
                    activado
                    descripcion
                    permiteEdicion
                  }
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
        variables: inputData,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.descuento_maximo.obtenerSegunFiltro;
        // self.log(respuesta)
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        self.paginationContext.RecordsCount = totalRegistros;
        self.paginationContext.CurrentPage = paginaActual;
        self.paginationContext.PagesCount = totalPaginas;
        // self.log(self.paginationContext)
        self.listaDescuentos = registros;
        //  self.data.map(cliente => { cliente.rutFormato = self.rutService.AgregarDV(cliente.rut) })
        self.loaded = true;
        self.loading = false;
      }
    );
  }

  /**LIMPIAR FILTRO */
  limpiarfiltros() {
    this.formValidatorsService.reset(this.formDetails);

    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formDetails.get('fechaInicio').setValue(initDate);
    this.formDetails.get('codigoProducto').setValue(null);
    this.formDetails.get('estadoActMax').setValue(this.RO_EstadoActivoMax);
    this.productosMultiplesSeleccionados = [];
  }

  abrirModalAgregarDescuento() {
    this.agregarDescuentoModal.show('ADD');
  }

  //DESPUES DE GUARDAR DESCUENTO REALIZAR BUSQUEDA
  onDescuentoSaved() {
    this.log('onDescuentoSaved');
    this.buscar(true);
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.buscar();
  }

  confirmDuplicar(codigo: number) {
    this.modalConfirmTitle = 'Duplicar descuento';
    this.modalConfirmContent = '¿Desea duplicar el descuento?';
    this.modalConfirm.show(() => {
      this.duplicar(codigo);
    });
  }

  duplicar(codigo: number) {
    const inputData = {
      cabecera: {
        codigo,
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
      },
      detalleProductos: [],
    };

    const self = this;
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoDTOMaximoInputType) {
            descuento_maximo {
              clonarDescuento(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_inicio
                    fecha_termino
                    activado
                    descripcion
                  }
                  detalleProductos {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    descuento_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: inputData,
        },
      },
      function (_respuesta) {
        self.log(_respuesta);
        const { mensajes, respuesta } = _respuesta.data.descuento_maximo.clonarDescuento;
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        } else {
          self.toastrService.success('Descuento duplicado con éxito');
          self.buscar(true);
        }
      }
    );
  }

  confirmDesactivar(descuento: any) {
    if (!descuento.permiteEdicion) {
      this.toastrService.error('El descuento no tiene permisos para ser desactivado');
      return;
    }

    if (descuento.activado) {
      this.modalConfirmTitle = 'Desactivar descuento';
      this.modalConfirmContent = '¿Desea desactivar el descuento?';
      this.modalConfirm.show(() => {
        this.DesactivarActivarDescuento(descuento.codigo, false);
      });
    } else {
      this.modalConfirmTitle = 'Activar descuento';
      this.modalConfirmContent = '¿Desea activar el descuento?';
      this.modalConfirm.show(() => {
        this.DesactivarActivarDescuento(descuento.codigo, true);
      });
    }


  }

  DesactivarActivarDescuento(codigo: number, activar: boolean) {
    const descuentoCliente = {
      codigo,
      rut_empresa: Number(this.rutEmpresa),
      sucursal_codigo: Number(this.sucursalEmpresa),
      activado: activar,
    };

    const self = this;
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoMaximoInputType) {
            descuento_maximo {
              cambiarEstado(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  activado
                }
              }
            }
          }
        `,
        variables: {
          entidad: descuentoCliente,
        },
      },
      function (_respuesta) {
        self.log(_respuesta);
        const { mensajes, respuesta } = _respuesta.data.descuento_maximo.cambiarEstado;
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        } else {
          self.toastrService.success('Descuento desactivado con éxito');
          self.buscar(true);
        }
      }
    );
  }
}
